'use client';
import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { cn } from '@/shared/lib/cn';
import './product-detail.scss';

type Props = ComponentProps<'a'>;

export const ProductDetailInfoShowMore = ({ className, ...props }: Props) => {
    const t = useTranslations();
    return (
        <a href="#detail" className={cn('product-detail__info-show-more', className)} {...props}>
            {t('WORDS.SHOW_MORE')}
        </a>
    );
};
